import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import InputControl from '~/components/Input/InputControl';
import MuiInputSelect from '~/components/Input/InputSelect';

import { editFilter } from '../../../../store/actions';

function InputSelect({
  filter,
  column,
  indexGroup,
  indexFilter,
  inputProps,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const options = useMemo(() => Object.keys(column.lookup).map(id => ({ id, name: column.lookup[id] })), [column.lookup]);

  return (
    <InputControl
      value={filter.get('value')}
      name={'value'}
      inputComponent={MuiInputSelect}
      InputProps={{
        placeholder: t('filter-label-value'),
        outValueType: 'string',
        options,
        ...inputProps,
      }}
      onChange={({ value }) => dispatch(editFilter(indexGroup, indexFilter, 'value', value))}
    />
  );
}

export default React.memo(InputSelect);
